import React from 'react'
import { intl } from 'lang/intl'

import { IconComponent } from '../../../../components'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'

import './NoQuestionsComponent.scss'

const NoQuestionsComponent = () => {
  const title = intl.formatMessage({
    defaultMessage:
      "This is where you'll find all the questions from the audience.",
  })
  const description = intl.formatMessage({
    defaultMessage:
      'These questions are not visible to the audience, unless they are presented in a TvCard.',
  })

  const webinarColors = useWebinarColors()

  return (
    <div className="no-questions-component">
      <div
        className="gutter"
        style={{ background: webinarColors.accent.color }}
      />
      <div className="content" style={{ background: webinarColors.tabs.color }}>
        <div className="icon-wrapper">
          <IconComponent name="comments" size={[20, 20]} color="FFFFFF" />
        </div>
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
    </div>
  )
}

export default NoQuestionsComponent
